import * as z from "zod";

export const disconnectSpsCommerceIntegration = {
  name: "disconnectSpsCommerceIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
